import { animate, style, transition, trigger } from "@angular/animations";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ViewWillEnter } from "@ionic/angular";

import { AppService } from "src/app/_services/app.service";
import { LocalStorageService } from "src/app/_services/localStorage.service";
import { NavigationService } from "src/app/_services/navigation-service.service";
import { environment } from "../../../environments/environment";
@Component({
  selector: "app-contact",
  templateUrl: "./contact.component.html",
  styleUrls: ["./contact.component.scss"],
  standalone: false,
  animations: [
    trigger("slideInTop", [
      transition(":enter", [
        style({ transform: "translateY(100%)", opacity: 0 }),
        animate(
          "500ms ease-out",
          style({ transform: "translateX(0%)", opacity: 1 })
        ),
      ]),
      transition(":leave", [
        style({ transform: "translateX(0%)", opacity: 1 }),
        animate(
          "5500ms ease-in",
          style({ transform: "translateX(-100%)", opacity: 0 })
        ),
      ]),
    ]),
  ],
})
export class ContactComponent implements OnInit, ViewWillEnter {
  role: any;
  phoneNumber = environment.servicesPhone;
  adminMessageCount: number = 0;
  @ViewChild("messageInput") messageInputRef!: ElementRef;
  @ViewChild("messageContainer") messageContainer!: ElementRef;
  callModal: boolean = false;
  constructor(
    private navigationService: NavigationService,
    private appService: AppService,
    private localStorageServices: LocalStorageService
  ) {
    this.role = this.localStorageServices.getUserRole();
  }

  ngOnInit() {}
  goBack() {
    this.navigationService.goToPreviousPage();
  }
  ionViewWillEnter(): void {
    this.adminMessageCount = this.appService.gethomeData();
  }
  handleCallModal(val: boolean) {
    this.callModal = val;
  }
  goToMessagerie(path: string, user?: any) {
    let baseUrl = "";
    switch (this.role) {
      case "client":
        baseUrl = "particulier";
        break;
      case "prestataire":
        baseUrl = "prestataire";
        break;
    }
    if (path === "messagerie") {
      // this.removeUnreadConversation(user);
      this.navigationService.navigateTo("/" + baseUrl + `/messagerie/admin`);
    } else {
      this.navigationService.navigateTo("/" + baseUrl + "/" + path);
    }
  }
}
